import React from 'react';
import { Container, Jumbotron } from 'reactstrap';
import { compose, pure } from 'recompose';
import './not-found.css';

const NotFound = ({ location: { pathname } }) => (
  <section className='not-found'>
    <Jumbotron tag='section' className='text-center'>
      <Container>
        <h1>
          404 Not Found
          <br />
          <code>{pathname}</code>
        </h1>
      </Container>
    </Jumbotron>
  </section>
);

export default compose(
  pure
)(NotFound);



// WEBPACK FOOTER //
// ./src/components/pages/not-found/not-found.js